import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { useForm } from 'react-hook-form';
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import PaymentMethodForm from './PaymentMethodForm';
import { paymentMethodValidationForm } from '../../utils/validationSchemas';

const EditPaymentMethod= (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm<any>({
    resolver: yupResolver(paymentMethodValidationForm),
    defaultValues: async () => {
      let data: any = await props?.refetch()
      return {
        ...data?.data
      }
    }
  });
  const { handleEdit, isLoading } = props;
  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleEdit}
      setError={setError}
      buttonLabel={"Update"}
      isLoading={isLoading}
    >
      <PaymentMethodForm
        errors={errors}
        register={register}
      />
    </FormLayout>

  );
}

export default EditPaymentMethod